import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from '../Reveal';
import { SectionEyebrow } from '../SectionEyebrow';
export const Author: React.FC = () => <section className="relative bg-navy-mid py-28 lg:py-40 overflow-hidden" data-id="element-62">
    <div className="absolute inset-0 sacred-grid opacity-15" data-id="element-63" />
    <div className="absolute inset-0" style={{
    background: 'radial-gradient(ellipse at 30% 40%, rgba(212,175,122,0.1), transparent 60%)'
  }} data-id="element-64" />

    <div className="relative max-w-5xl mx-auto px-6 lg:px-8" data-id="element-65">
      <div className="grid md:grid-cols-[auto_1fr] gap-10 lg:gap-16 items-center" data-id="element-66">
        <Reveal data-id="element-67">
          <div className="relative w-40 h-40 sm:w-44 sm:h-44 lg:w-56 lg:h-56 mx-auto" data-id="element-68">
            {/* Animated outer glow ring */}
            <motion.div className="absolute -inset-3 rounded-full" animate={{
            rotate: 360
          }} transition={{
            duration: 12,
            repeat: Infinity,
            ease: 'linear'
          }} style={{
            background: 'conic-gradient(from 0deg, transparent 0%, rgba(212,175,122,0.6) 12%, transparent 24%, transparent 50%, rgba(229,200,150,0.5) 62%, transparent 74%, transparent 100%)',
            padding: '1.5px'
          }} data-id="element-69">
              <div className="w-full h-full rounded-full bg-navy-mid" data-id="element-70" />
            </motion.div>
            <div className="absolute -inset-1 rounded-full border border-gold/70" data-id="element-71" />
            {/* Avatar */}
            <div className="w-full h-full rounded-full overflow-hidden flex items-center justify-center relative" style={{
            background: 'radial-gradient(circle at 30% 30%, #2a3560 0%, #162449 50%, #0A1128 100%)',
            boxShadow: 'inset 0 0 40px rgba(212,175,122,0.25), 0 20px 60px -10px rgba(0,0,0,0.6)'
          }} data-id="element-72">
              {/* Inner glow accent */}
              <div className="absolute inset-0 rounded-full" style={{
              background: 'radial-gradient(circle at 35% 30%, rgba(212,175,122,0.18), transparent 55%)'
            }} data-id="element-73" />
              <span className="relative font-serif italic text-gold text-4xl sm:text-5xl lg:text-6xl" style={{
              fontWeight: 400,
              textShadow: '0 0 20px rgba(212,175,122,0.5)'
            }} data-id="element-74">
                DN
              </span>
            </div>
            {/* Glow */}
            <div className="absolute -inset-8 rounded-full blur-2xl opacity-40 -z-10" style={{
            background: 'radial-gradient(circle, rgba(212,175,122,0.4), transparent 60%)'
          }} data-id="element-75" />
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-76">
          <SectionEyebrow data-id="element-77">El autor</SectionEyebrow>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-ivory mb-6 leading-[1.1]" style={{
          fontWeight: 300
        }} data-id="element-78">
            Sobre{' '}
            <span className="italic gold-text" style={{
            fontWeight: 400
          }} data-id="element-79">
              Daniel Navarro
            </span>
          </h2>
          <div className="divider-gold w-24 mb-7" data-id="element-80" />
          <div className="space-y-4 text-ivory/70 leading-[1.85] font-light" data-id="element-81">
            <p data-id="element-82">
              Daniel Navarro escribe desde una búsqueda profunda de equilibrio,
              propósito y conexión espiritual. Su obra nace como una invitación
              a mirar la vida desde una perspectiva más amplia, integrando
              cuerpo, mente, emociones, intuición y vocación en un camino de
              plenitud consciente.
            </p>
            <p data-id="element-83">
              <span className="font-serif italic text-ivory" data-id="element-84">
                La Estabilidad Dimensional de Nuestro Ser
              </span>{' '}
              es una obra creada desde la reflexión, la experiencia, la
              sensibilidad espiritual y el deseo de compartir un mapa que ayude
              a otros a volver a sí mismos.
            </p>
            <p className="text-sm text-gold/80 italic font-serif pt-2" data-id="element-85">
              Con apoyo creativo de César Navarro.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>;